import { collection, addDoc, deleteDoc, Timestamp } from 'firebase/firestore';
import { db } from '../lib/firebase';

export async function testFirebaseConnection() {
  try {
    // 1. Test write operation
    const testDoc = await addDoc(collection(db, '_test_connection'), {
      timestamp: Timestamp.now(),
      message: 'Test connection'
    });

    // 2. Test delete operation (cleanup)
    await deleteDoc(testDoc);

    return {
      success: true,
      message: 'Firebase connection successful'
    };
  } catch (error: any) {
    return {
      success: false,
      message: error.message || 'Firebase connection failed'
    };
  }
}